export * from './config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-webstorage/dist/interfaces/index.js
// module id = ../../../../ngx-webstorage/dist/interfaces/index.js
// module chunks = 18